<template>
  <div class="controlpanel-page">
    <h1>群发邮件</h1>
    <el-divider></el-divider>
    <div class="controlpanel-container">
      <el-form>
        <el-form-item>
          <el-input v-model="emailtitle" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="textarea"
            :rows="10"
            placeholder="请输入内容"
            v-model="message">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onClick()">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      emailtitle: '',
      message: ''
    }
  },
  methods: {
    onClick: function(){
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/admin/batchsendemail'+'?token='+that.getLocalStorage('admintoken')+'';
      let datamessage = {
        title: that.emailtitle,
        content: that.message,
      }
      console.log(that.getLocalStorage('admintoken'))
      console.log("Intro Info", datamessage)
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(datamessage),
        contentType: "application/json",
        success: function(data) {
          console.log('success', data)
          if(data.code === 200){
            that.$message({
              duration: 0,
              offset: 80,
              showClose: true,
              message: data.error,
              type: 'success'
            })            
          }else{
            that.$message({
              duration: 0,
              offset: 80,
              showClose: true,
              message: data.error,
              type: 'error'
            })            
          } 
        },
        error: function(response) {
          console.log('error', response)
        }
      })
    },
  }
}
</script>
